/* eslint-disable camelcase */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { v4 as uuidv4 } from "uuid";
import config from "../../../config";
import AdobeCookies from "./adobeCookies";
import { storage, parseQueryString, getContext } from "./utils";
import { get as storageGet } from "../../storage";
import poll from "../../poll";
import { getFlag, getPersonalizationClientId } from "../../ld-cache";
import logger from "../../../logger";
export var AB_TESTING_DELIVERY_MODE = "AB_TESTING_DELIVERY_MODE";
export var deliveryModes = {
    TEST: "TEST",
    LPE: "LPE",
    DIRECT: "DIRECT",
    AKAMAI: "AKAMAI"
};
var isVisitorReady = poll(function(resolve) {
    /* eslint-disable-next-line no-undef */ if (typeof s !== "undefined" && s && s.visitor) {
        /* eslint-disable-next-line no-undef */ resolve(s.visitor);
    }
}, 16, 10000).catch(function(error) {
    logger.error(error);
    return false;
});
var PERSONALIZATION_HOST_KEY = "personalizationHost";
var LPE_API_PATH = "/adobe/target/delivery";
///api/personalization/adobe/target/delivery
export var MAX_MBOXES_PER_REQUEST = 50;
var getProtocol = function(clientHost) {
    var _clientHost;
    return ((_clientHost = clientHost) == null ? void 0 : _clientHost[0]) === "localhost" ? "http://" : "https://";
};
var getDeliveryDirectURL = function(mode, sessionId) {
    var baseHost = mode === deliveryModes.DIRECT ? "smetrics.lululemon.com" : window.location.host.includes(".lululemon.com") ? window.location.host : "shop.lululemon.com";
    var basePath = "/rest/v1/delivery?client=lululemonusa&sessionId=" + sessionId;
    var basePathLPE = "/api/personalization/adobe/target/delivery";
    if (mode === deliveryModes.AKAMAI) {
        return baseHost + "/dao" + basePath;
    } else if (mode === deliveryModes.DIRECT) {
        return baseHost + basePath;
    } else {
        return baseHost + basePathLPE;
    }
};
export var getPersonalizationHost = function(param, param1) {
    var mode = param.mode, _param_sessionId = param.sessionId, sessionId = _param_sessionId === void 0 ? "required-id-false-fallback-session" : _param_sessionId;
    var config = param1.config, storageGet = param1.storageGet;
    try {
        var personalizationHost = storageGet(PERSONALIZATION_HOST_KEY);
        if (!personalizationHost) {
            personalizationHost = config().mboxes.personalizationHost;
        }
        var deliveryDirectURL = getDeliveryDirectURL(mode, sessionId);
        var clientHost = window.location.hostname.split(".");
        var protocol = getProtocol(clientHost);
        if (deliveryModes[mode] === deliveryModes.DIRECT || deliveryModes[mode] === deliveryModes.AKAMAI) {
            return protocol + deliveryDirectURL;
        } else if (personalizationHost) {
            return "" + personalizationHost + LPE_API_PATH;
        } else {
            // https://shop.lululemon.com/api/personalization/adobe/target/delivery
            return protocol + deliveryDirectURL;
        }
    } catch (err) {
    // do nothing
    }
};
var _AdobeCookies_cookieKey;
var definePropertyWithStorage = function(key, cookieKey, parse) {
    if (parse === void 0) parse = function(x) {
        return x;
    };
    return {
        get: function() {
            var _storage;
            return parse((_AdobeCookies_cookieKey = AdobeCookies[cookieKey]) != null ? _AdobeCookies_cookieKey : (_storage = storage) == null ? void 0 : _storage[key]);
        },
        set: function(value) {
            AdobeCookies[cookieKey] = value;
            storage[key] = value;
        },
        enumerable: true
    };
};
// Setters and gettings for storing values in some kind of storage (localStorage)
var adobeValues = Object.defineProperties({}, {
    marketingCloudVisitorId: definePropertyWithStorage("lapel_adobe_marketingCloudVisitorId", "MCMID"),
    tntId: definePropertyWithStorage("lapel_adobe_tntId", "PC"),
    thirdPartyId: definePropertyWithStorage("lapel_adobe_thirdPartyId", null),
    sessionId: {
        get: function() {
            var _AdobeCookies_session;
            var value = (_AdobeCookies_session = AdobeCookies.session) != null ? _AdobeCookies_session : storage.lapel_adobe_sessionId;
            if (!value) {
                value = Date.now() + "_" + uuidv4();
                AdobeCookies.session = value;
                storage.lapel_adobe_sessionId = value;
            }
            return value;
        },
        set: function(value) {
            AdobeCookies.session = value;
            storage.lapel_adobe_sessionId = value;
        },
        enumerable: true
    },
    trace: {
        get: function() {
            var _parseQueryString = parseQueryString(), mboxTrace = _parseQueryString.mboxTrace, authorization = _parseQueryString.authorization;
            if (mboxTrace) {
                // mboxTrace is all that's required
                var value = {
                    mboxTrace: mboxTrace.toLowerCase(),
                    authorizationToken: authorization
                };
                storage.lapel_adobe_trace = JSON.stringify(value);
                return value;
            }
            try {
                return JSON.parse(storage.lapel_adobe_trace);
            } catch (err) {
            // do nothing
            }
            return {};
        },
        set: function(value) {
            storage.lapel_adobe_trace = JSON.stringify(value);
        }
    },
    qaMode: {
        get: function() {
            var _parseQueryString = parseQueryString(), at_preview_token = _parseQueryString.at_preview_token, at_preview_index = _parseQueryString.at_preview_index, at_preview_listed_activities_only = _parseQueryString.at_preview_listed_activities_only, at_preview_evaluate_as_true_audience_ids = _parseQueryString.at_preview_evaluate_as_true_audience_ids;
            if (at_preview_token !== undefined && at_preview_index !== undefined) {
                var activityIndex = parseInt(at_preview_index.split("_")[0], 10);
                var experienceIndex = parseInt(at_preview_index.split("_")[1], 10);
                var qaVals = {
                    evaluateAsTrueAudienceIds: at_preview_evaluate_as_true_audience_ids ? [
                        at_preview_evaluate_as_true_audience_ids
                    ] : [],
                    evaluateAsFalseAudienceIds: [],
                    previewIndexes: [
                        {
                            activityIndex: Number.isNaN(activityIndex) ? null : activityIndex,
                            experienceIndex: Number.isNaN(experienceIndex) ? null : experienceIndex
                        }
                    ],
                    token: at_preview_token,
                    listedActivitiesOnly: !!at_preview_listed_activities_only
                };
                storage.lapel_adobe_qaMode = JSON.stringify(qaVals);
                return qaVals;
            }
            try {
                var _AdobeCookies_at_qa_mode;
                return (_AdobeCookies_at_qa_mode = AdobeCookies.at_qa_mode) != null ? _AdobeCookies_at_qa_mode : JSON.parse(storage.lapel_adobe_qaMode);
            } catch (err) {
            // do nothing
            }
            return undefined;
        },
        set: function(value) {
            AdobeCookies.at_qa_mode = value;
            storage.lapel_adobe_qaMode = JSON.stringify(value);
        },
        enumerable: true
    },
    locationHint: definePropertyWithStorage("lapel_adobe_locationHint", "MCAAMLH", function(value) {
        var temp = parseInt(value, 10);
        return Number.isNaN(temp) ? 1 : temp;
    }),
    serverState: definePropertyWithStorage("lapel_adobe_serverSate", "MCAAMB"),
    cluster: definePropertyWithStorage("lapel_adobe_cluster", "mboxEdgeCluster", function(value) {
        var intValue = parseInt(value, 10);
        return Number.isNaN(intValue) ? undefined : intValue;
    })
});
// Fetch AdobeTarget mbox results from peps-personalization-engine API
var POST = /*#__PURE__*/ _async_to_generator(function(param) {
    var body, url;
    return _ts_generator(this, function(_state) {
        body = param.body, url = param.url;
        // Execute request to ecom-personalization-engine
        return [
            2,
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            })
        ];
    });
});
var isSessionValid = function() {
    return adobeValues.marketingCloudVisitorId && adobeValues.locationHint && adobeValues.serverState;
};
// eslint-disable-next-line consistent-return
var hasSession = /*#__PURE__*/ _async_to_generator(function() {
    return _ts_generator(this, function(_state) {
        // Check for a valid session and check for a marketingCloudVisitorId
        if (!isSessionValid()) {
            return [
                2,
                poll(function(resolve) {
                    if (adobeValues.marketingCloudVisitorId) {
                        resolve(true);
                    }
                }, 16, 10000).catch(function(error) {
                    logger.error(error);
                    return false;
                })
            ];
        }
        return [
            2,
            true
        ];
    });
});
var getRequestBody = /*#__PURE__*/ _async_to_generator(function(request, adobeValues, abTestingDeliveryMode) {
    var marketingCloudVisitorId, tntId, thirdPartyId, sessionId, _adobeValues_trace, authorizationToken, mboxTrace, qaMode, locationHint, serverState, cluster, sdid, baseBody;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                marketingCloudVisitorId = adobeValues.marketingCloudVisitorId, tntId = adobeValues.tntId, thirdPartyId = adobeValues.thirdPartyId, sessionId = adobeValues.sessionId, _adobeValues_trace = adobeValues.trace, authorizationToken = _adobeValues_trace.authorizationToken, mboxTrace = _adobeValues_trace.mboxTrace, qaMode = adobeValues.qaMode, locationHint = adobeValues.locationHint, serverState = adobeValues.serverState, cluster = adobeValues.cluster;
                return [
                    4,
                    isVisitorReady.then(function(visitor) {
                        return(// eslint-disable-next-line no-underscore-dangle
                        visitor._supplementalDataIDCurrent ? visitor._supplementalDataIDCurrent : visitor.getSupplementalDataID());
                    })
                ];
            case 1:
                sdid = _state.sent();
                baseBody = _extends({}, request, {
                    context: getContext(),
                    id: {
                        marketingCloudVisitorId: marketingCloudVisitorId,
                        tntId: tntId,
                        thirdPartyId: thirdPartyId
                    },
                    requestId: uuidv4(),
                    trace: authorizationToken && mboxTrace !== "disabled" ? {
                        authorizationToken: authorizationToken
                    } : undefined,
                    qaMode: qaMode,
                    experienceCloud: {
                        audienceManager: {
                            blob: serverState,
                            locationHint: locationHint
                        },
                        analytics: {
                            logging: "server_side",
                            supplementalDataId: sdid,
                            trackingServer: "metrics.lululemon.com",
                            trackingServerSecure: "smetrics.lululemon.com"
                        }
                    }
                });
                if (abTestingDeliveryMode === deliveryModes.LPE) {
                    baseBody.cluster = cluster;
                    baseBody.sessionId = sessionId;
                }
                if (abTestingDeliveryMode !== deliveryModes.LPE) {
                    baseBody.property = {
                        token: "44f9a1ae-90ed-4d03-9169-943014234b72"
                    };
                }
                return [
                    2,
                    baseBody
                ];
        }
    });
});
var delivery = /*#__PURE__*/ _async_to_generator(function(request) {
    var deliveryCallsAllowed, abTestingDeliveryMode, personalizationHost, body, response, respJson, tmp, _ref, newTntId, edgeHost, newCluster, err;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                deliveryCallsAllowed = getFlag("allow-lapel-delivery-calls", true, getPersonalizationClientId());
                abTestingDeliveryMode = storageGet(AB_TESTING_DELIVERY_MODE) || deliveryModes.LPE;
                if (!deliveryCallsAllowed) {
                    throw new Error("Requests disabled by launchDarkly flag");
                }
                return [
                    4,
                    hasSession()
                ];
            case 1:
                if (!_state.sent()) {
                    throw new Error("Unable to get session");
                }
                personalizationHost = getPersonalizationHost({
                    mode: abTestingDeliveryMode,
                    sessionId: adobeValues.sessionId
                }, {
                    config: config,
                    storageGet: storageGet
                });
                if (!personalizationHost) {
                    throw new Error("Unable to get personalizationHost");
                }
                return [
                    4,
                    getRequestBody(request, adobeValues, abTestingDeliveryMode)
                ];
            case 2:
                body = _state.sent();
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    7
                ]);
                return [
                    4,
                    POST({
                        url: "" + personalizationHost,
                        body: body
                    })
                ];
            case 4:
                response = _state.sent();
                if (response.status !== 200) {
                    throw new Error("LPE has failed: Status " + response.status, response);
                }
                return [
                    4,
                    response.json()
                ];
            case 5:
                respJson = _state.sent();
                tmp = respJson.id, _ref = tmp === void 0 ? {} : tmp, newTntId = _ref.tntId, edgeHost = respJson.edgeHost;
                if (newTntId) {
                    adobeValues.tntId = newTntId;
                }
                if (edgeHost) {
                    newCluster = parseInt(edgeHost.split(".")[0].slice("mboxedge".length), 10);
                    adobeValues.cluster = newCluster;
                }
                return [
                    2,
                    respJson
                ];
            case 6:
                err = _state.sent();
                throw new Error("" + err.message);
            case 7:
                return [
                    2
                ];
        }
    });
});
export { delivery, adobeValues };

//# sourceMappingURL=delivery.js.map